import {
  formSpecification as commonFormSpecification,
  type McaCapacityAssessmentFormData as CommonMcaCapacityAssessmentFormData,
} from "../common/mcaCapacityAssessment.js";

export const formSpecification = commonFormSpecification;

export type McaCapacityAssessmentFormData = CommonMcaCapacityAssessmentFormData;
